async function CheckLogin(host) {
    const token = localStorage.getItem("token");
    if (!token || token === "null" || token === "undefined") {
        return false;
    }

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 12000);

    try {
        const result = await fetch(`${host}/account/get-profile`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
            },
            signal: controller.signal,
        });

        if (result.status === 200) {
            return await result.json();
        }
        return false;
    } catch {
        return false;
    } finally {
        clearTimeout(timeoutId);
    }
}

export default CheckLogin;
